module.exports = __webpack_public_path__ + "static/media/02 Category.ac89b53b.png";